/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

const SEO = ({
  description,
  lang,
  meta,
  title,
  canonical,
  noIndex,
  imgMeta,
}) => {
  const { site, cover } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
        cover: file(relativePath: { eq: "cover.jpg" }) {
          childImageSharp {
            fluid {
              src
            }
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={`%s | ${site.siteMetadata.author}`}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata.author,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
        {
          property: `og:site_name`,
          content: "Nis Media",
        },
        {
          property: `og:url`,
          content: process.env.GATSBY_HOST + canonical,
        },
        {
          property: `og:image`,
          content: `${process.env.GATSBY_HOST}${
            imgMeta || cover.childImageSharp.fluid.src
          }`,
        },
        {
          property: `og:image:width`,
          content: "1200",
        },
        {
          property: `og:image:height`,
          content: "630",
        },
      ].concat(meta)}
    >
      {/* <script
        type="text/javascript"
        src="https://cdn.weglot.com/weglot.min.js"
      />
      <script>
        {`
    Weglot.initialize({
        api_key: 'wg_cce408b8207e2957d25c5583769f78747'
    });
`}
      </script> */}

      {noIndex && <meta name="robots" content="noindex,follow" />}
      {canonical && (
        <link rel="canonical" href={process.env.GATSBY_HOST + canonical} />
      )}

      {/* <script>
        {`window.customerlySettings = {
              app_id: "5535b0f8"
          };
          !function(){function e(){var e=t.createElement("script");
          e.type="text/javascript",e.async=!0,
          e.src="https://widget.customerly.io/widget/5535b0f8";
          var r=t.getElementsByTagName("script")[0];r.parentNode.insertBefore(e,r)}
          var r=window,t=document,n=function(){n.c(arguments)};
          r.customerly_queue=[],n.c=function(e){r.customerly_queue.push(e)},
          r.customerly=n,r.attachEvent?r.attachEvent("onload",e):r.addEventListener("load",e,!1)}();`}
      </script> */}

      {/* <!-- Facebook Pixel Code --> */}
      <script>
        {`!function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '2747232612163755');
        fbq('track', 'PageView');`}
      </script>
      <noscript>
        {` <img
          height="1"
          width="1"
          style="display:none"
          src="https://www.facebook.com/tr?id=2747232612163755&ev=PageView&noscript=1"
        />`}
      </noscript>
      {/* <!-- End Facebook Pixel Code --> */}
    </Helmet>
  )
}

SEO.defaultProps = {
  lang: `pl`,
  meta: [],
  description: ``,
  noIndex: false,
  imgMeta: null,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
  canonical: PropTypes.string.isRequired,
  noIndex: PropTypes.bool,
  imgMeta: PropTypes.string,
}

export default SEO
